import { CSSProperties, FC } from 'react';
import { Avatar, Button, Col, Row } from 'antd';
import { TbCircleArrowUp, TbLockAccess } from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';

import { FeatureAddOnKey, PlanKey } from '@/constants';
import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { FeatureAddOnPopover, PlanPopover } from '@/shared';
import { centerComponentInMiddleofView } from '@/utilities';

interface NotAvailableProps {
    planRequired: PlanKey;
    featureAddOnRequired?: FeatureAddOnKey;
    height?: CSSProperties['height'];
}

const NotAvailable: FC<NotAvailableProps> = ({ planRequired = 'plus', featureAddOnRequired, height }): JSX.Element => {
    const navigate = useNavigate();

    const { token } = useAntDesignTheme();

    return (
        <span
            style={{
                ...centerComponentInMiddleofView,
                height: height ?? '100%',
                minHeight: 0,
            }}
        >
            <Avatar
                size={16 * 2.5}
                shape='square'
                style={{ border: `1px solid ${token.colorBorder}` }}
                icon={<TbLockAccess size='75%' style={{ color: token.colorTextTertiary }} />}
            />
            <div style={{ margin: '0.5rem 0', marginTop: '0.75rem', fontWeight: 500, color: token.colorTextSecondary }}>
                Feature Not Available
            </div>
            <div style={{ maxWidth: '20rem', textAlign: 'center' }}>
                <span style={{ color: token.colorTextTertiary, lineHeight: '1.25rem' }}>
                    This feature is not available under your current plan. This feature requires the following:
                </span>
            </div>
            <Row style={{ margin: '1rem 0' }} wrap={false} gutter={[8, 0]} align='middle'>
                <Col flex='none'>
                    <PlanPopover plan={planRequired ?? 'plus'} />
                </Col>
                {featureAddOnRequired && (
                    <Col flex='none'>
                        <FeatureAddOnPopover itemKey={featureAddOnRequired ?? 'relations'} />
                    </Col>
                )}
            </Row>
            <Button
                onClick={() => navigate('/settings/account/plans')}
                icon={<TbCircleArrowUp size='1rem' style={{ verticalAlign: '-0.175rem' }} />}
                type='primary'
                style={{ marginTop: '0.25rem' }}
            >
                Upgrade
            </Button>
        </span>
    );
};

export default NotAvailable;
